import { combineReducers } from "@reduxjs/toolkit";

import {
	accountsExecutorsDataState,
	accountsExecutorsDataReducer,
	accountsExecutorsDataAction,
} from "./data";
import {
	accountsExecutorsDataModalState,
	accountsExecutorsDataModalReducer,
	accountsExecutorsDataModalAction,
} from "./dataModal";

export type StateExecutors = {
	data: accountsExecutorsDataState;
	dataModal: accountsExecutorsDataModalState;
};

export const executors = combineReducers<StateExecutors>({
	data: accountsExecutorsDataReducer,
	dataModal: accountsExecutorsDataModalReducer,
});

export const accountsExecutorsAction = {
	data: accountsExecutorsDataAction,
	dataModal: accountsExecutorsDataModalAction,
};

export default executors;
